/* eslint-disable array-callback-return */
/* eslint-disable @typescript-eslint/no-explicit-any */
import debounce from 'lodash.debounce'
import React, {
  FC,
  useState,
  useEffect,
  useContext,
  useRef,
  useMemo,
} from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import Cookies from 'universal-cookie'

import { searchContratByTextAndOrganizationsIds } from 'services/contract-services'
import { ActionTypes } from 'store/actions'
import { AppContext } from 'store/context'
import ContractEntity from 'utils/__interfaces/Perimeter/ContractEntity'
import { useElementSizeListener } from 'utils/Common/screen-utils'
import isCancel from 'utils/Common/api-utils'
import { isSuperAdmin } from 'services/roles-services'
import SearchResultItem from 'utils/__interfaces/Perimeter/SearchResultItem'
import SearchContractAdapter from 'adapter/SearchContractAdapter'
import SvgIcon from 'components/Icons/SvgIcon'
import SelectedItems from 'components/molecules/SelectedItems'
import SmartSelect from './SmartSelect'

interface Props {
  disableGlobalState?: boolean
  onSearchValidate?: (contracts: ContractEntity[]) => void
  initialContrats?: ContractEntity[]
  isContratsAlreadySet?: boolean
  organizationSetted?: boolean
  forceReset?: boolean
  forceUnfold?: boolean
  isCollapsedSearch?: boolean
  onHandlerCollapsedSearch?: (SearchValue: string) => void
  onContratsSetted?: () => void
  selectedContrats?: ContractEntity[]
  displaySelected?: boolean
  disabledSearch?: boolean
  expandedMode?: boolean
  isBandeau?: boolean
}

const SmartSelectContract: FC<Props> = ({
  disableGlobalState,
  onSearchValidate,
  initialContrats,
  isContratsAlreadySet,
  organizationSetted,
  forceReset,
  forceUnfold,
  isCollapsedSearch,
  onHandlerCollapsedSearch,
  onContratsSetted,
  selectedContrats,
  displaySelected,
  disabledSearch,
  expandedMode,
  isBandeau,
}: Props) => {
  const { t } = useTranslation()
  const history = useHistory()
  const cookies = new Cookies()

  const {
    state: { user, contract, organization, impersonnation },
    dispatch,
  } = useContext(AppContext)

  // STATE
  const [entities, setEntities] = useState<ContractEntity[]>([])
  const [totalItems, setTotalItems] = useState(0)
  const [searchValue, setSearchValue] = useState('')
  const [isLoading, setIsLoading] = React.useState(false)
  const [
    resetSearchValueAfterValidate,
    setResetSearchValueAfterValidate,
  ] = useState<boolean>(false)
  const [selectedItems, setSelectedItems] = React.useState<SearchResultItem[]>(
    []
  )
  const selectRef = useRef(null)
  const { width: elementSize } = useElementSizeListener(selectRef)

  const searchContratItems = useMemo(() => {
    return SearchContractAdapter(entities)
  }, [entities])

  const initialItems = initialContrats
    ? SearchContractAdapter(initialContrats)
    : undefined
  const selectedContratsItem = selectedContrats
    ? SearchContractAdapter(selectedContrats)
    : []
  const callApiAsync = async (organizationIds: string[]) => {
    const maxTotalLimit = parseInt(
      `${process.env.REACT_APP_FILTER_MAX_ORGANIZATION}`,
      10
    )

    /* eslint-disable-next-line no-param-reassign */
    if (isContratsAlreadySet) organizationIds = []
    try {
      setIsLoading(true)
      const {
        entities: resultEntities,
        totalItems: resultTotalItems,
      } = await searchContratByTextAndOrganizationsIds(
        searchValue,
        organizationIds,
        history,
        maxTotalLimit,
        disableGlobalState,
        200,
        expandedMode
      )
      if (isCancel(entities)) {
        return
      }
      if (resultEntities) {
        // dispatch contractPerimeter initial without filters organizations or contracts
        if (organizationIds.length === 0 && searchValue.length === 0) {
          dispatch({
            type: ActionTypes.SET_CONTRACT_PERIMETER,
            payload: {
              contractPerimeter: resultEntities,
              count: resultTotalItems,
            },
          })
          if (contract.items.length === 0) {
            dispatch({
              type: ActionTypes.SET_CONTRACT_COUNT,
              payload: {
                count: resultTotalItems,
              },
            })
          }
        }
        setEntities(resultEntities)
        setTotalItems(resultTotalItems)
      }

      setIsLoading(false)
    } catch (e) {
      setIsLoading(false)
      console.debug(e)
    }
  }

  const handleContratChanged = async (value: string) => {
    setSearchValue(value)
  }

  const handleContratChangedDebounced = debounce(handleContratChanged, 1000)
  const HandlerCollapsedSearch = async (value: string) => {
    setSearchValue(value)
    if (onHandlerCollapsedSearch) onHandlerCollapsedSearch(value)
  }
  const HandlerCollapsedSearchDebounced = debounce(HandlerCollapsedSearch, 1000)

  const handleContratSearchValidated = (selectedItemIds: any[]) => {
    setResetSearchValueAfterValidate(true)
    const listIdContrat: string[] = []

    if (selectedItemIds.length > 0) {
      dispatch({
        type: ActionTypes.SET_CONTRACT_VALIDATED,
        payload: {
          contractValidated: true,
        },
      })
    }

    if (!disableGlobalState)
      contract.items.forEach((item: ContractEntity) => {
        listIdContrat.push(item.id)
      })

    const removeContrat: string[] = []

    const whichOne =
      initialContrats && initialContrats.length > entities.length
        ? initialContrats
        : entities
    whichOne.forEach((ent: ContractEntity) => {
      if (!selectedItemIds.includes(ent.id) && listIdContrat.includes(ent.id)) {
        removeContrat.push(ent.id)
      }
    })

    const fullResult: ContractEntity[] = []
    whichOne.forEach((item: ContractEntity) => {
      if (
        !listIdContrat.includes(item.id) &&
        selectedItemIds.includes(item.id)
      ) {
        fullResult.push(item)
      }
    })

    const tmpResult = !disableGlobalState
      ? [...contract.items, ...fullResult]
      : fullResult

    const finalResult = tmpResult.filter(
      (item) => !removeContrat.includes(item.id)
    )

    if (onContratsSetted) {
      onContratsSetted()
    }

    if (disableGlobalState) {
      if (onSearchValidate) onSearchValidate(finalResult)
    } else {
      dispatch({
        type: ActionTypes.SET_CONTRACT_LIST,
        payload: {
          contractList: [...finalResult],
        },
      })
      dispatch({
        type: ActionTypes.SET_CONTRACT_COUNT,
        payload: {
          count: finalResult.length,
        },
      })
      const contratsList = JSON.stringify(
        finalResult.map((itm: ContractEntity) => itm.id)
      )
      // put contract in cookies
      if (!impersonnation.isImpersonnation) {
        if (contratsList !== '[]') {
          cookies.set('chosenContrat', contratsList, {
            path: '/',
            secure: true,
          })
        } else {
          cookies.remove('chosenContrat', { path: '/' })
        }
      }
    }
  }

  // EFFECTS
  useEffect(() => {
    if (contract.items.length > 0) {
      setIsLoading(true)
      setIsLoading(false)
    } else if (initialContrats) {
      setIsLoading(true)
      setEntities(initialContrats)
      setTotalItems(initialContrats.length)
      setIsLoading(false)
    } else {
      setIsLoading(true)
      setEntities([])
      setTotalItems(0)
      setIsLoading(false)
    }
  }, [contract, forceUnfold])

  useEffect(() => {
    setResetSearchValueAfterValidate(false)
    if (initialContrats && initialContrats.length > 0) {
      setIsLoading(true)
      setEntities(initialContrats)
      setTotalItems(initialContrats.length)
      setIsLoading(false)
    }
  }, [initialContrats, forceUnfold])

  useEffect(() => {
    if (!organizationSetted) {
      setIsLoading(true)
      setSearchValue('')
      setEntities([])
      setTotalItems(0)
      setIsLoading(false)
    }
  }, [forceUnfold, organizationSetted])

  useEffect(() => {
    if (
      user.roleNames.length &&
      ((isSuperAdmin(user.roleNames) && searchValue.length) ||
        !isSuperAdmin(user.roleNames) ||
        organization.items.length > 0)
    ) {
      // empty array, means access to all organization
      let organizationIds: string[] = []
      organizationIds =
        organization.items.length > 0 ? organization.items.map((o) => o.id) : []

      if (
        !initialContrats ||
        initialContrats.length === 0 ||
        !organizationSetted
      ) {
        callApiAsync(organizationIds)
      } else {
        const resultEntities = initialContrats.filter(
          (item: ContractEntity) =>
            item.name.toLowerCase().includes(searchValue.toLowerCase()) ||
            item.numeroContratSAP
              .toLowerCase()
              .includes(searchValue.trim().toLowerCase()) ||
            item.address.toLowerCase().includes(searchValue.toLowerCase()) ||
            item.villeCP.toLowerCase().includes(searchValue.toLowerCase())
        )
        setEntities(resultEntities)
        setTotalItems(resultEntities.length)
      }
    }
  }, [organization, searchValue, user])

  useEffect(() => {
    setResetSearchValueAfterValidate(true)
  }, [organization, user])

  useEffect(() => {
    setEntities([])
    setTotalItems(0)
  }, [forceReset])

  const handleItemsSelected = (items: any) => {
    // 👇️ take parameter passed from Child component
    setSelectedItems([...selectedItems, items])
  }
  const handleItemsUnselected = (item: any) => {
    setSelectedItems(selectedItems.filter((e) => e.id !== item))
  }
  const onItemUnselected = (toDeleteId: string) => {
    const newSelectedItems = selectedItems.filter(
      (item) => toDeleteId !== item.id
    )
    const contratsList = JSON.stringify(
      newSelectedItems.map((itm: SearchResultItem) => itm.id)
    )
    cookies.set('chosenContrat', contratsList, {
      path: '/',
      secure: true,
    })
    handleContratSearchValidated(JSON.parse(contratsList))
    setSelectedItems([...newSelectedItems])
  }
  const selectedPlaceholder =
    selectedContratsItem.length > 1
      ? `${selectedContratsItem.length} ${t(
          'perimeterfilter.select.contracts.multi'
        )}`
      : `${selectedContratsItem.length} ${t(
          'perimeterfilter.select.contracts.single'
        )}`
  useEffect(() => {
    setSelectedItems(selectedContratsItem)
  }, [contract])

  return (
    <div className="perimeter-filter__select" ref={selectRef}>
      <SmartSelect
        isCollapsedSearch={isCollapsedSearch}
        onHandlerCollapsedSearch={HandlerCollapsedSearchDebounced}
        parentWidth={elementSize}
        placeholder={
          <>
            <SvgIcon
              name="building"
              className="perimeter-filter__select-icon"
            />
            <span>{t('perimeterfilter.placeholder.select')}</span>
          </>
        }
        selectedPlaceholderSingle={t('perimeterfilter.select.contracts.single')}
        selectedPlaceholderMulti={t('perimeterfilter.select.contracts.multi')}
        countLabel={
          searchContratItems.length <= 1
            ? t('perimeterfilter.search.resultContract.single')
            : t('perimeterfilter.search.resultContract.multi')
        }
        count={totalItems}
        searchResults={searchContratItems}
        displaySelected={displaySelected}
        resetSearchValue={resetSearchValueAfterValidate}
        isLoading={isLoading}
        forceReset={forceReset}
        forceUnfold={forceUnfold}
        onSearchChanged={handleContratChangedDebounced}
        onSearchValidated={handleContratSearchValidated}
        initialValues={initialItems}
        selectedItemsProp={selectedContratsItem}
        disabledSearch={disabledSearch}
        isBandeau={isBandeau}
        dataTest="smartContract"
        handleItemsSelected={handleItemsSelected}
        handleItemsUnselected={handleItemsUnselected}
        itemsSelected={selectedItems}
        organizationSetted={organizationSetted}
        isOrga={false}
      />
      {isBandeau && selectedContratsItem && selectedItems.length > 0 && (
        <SelectedItems
          placeholder={selectedPlaceholder}
          items={selectedItems}
          entityAbbreviation={t('perimeterfilter.search.contractAbbreviation')}
          onUnselect={onItemUnselected}
        />
      )}
    </div>
  )
}
SmartSelectContract.defaultProps = {
  disableGlobalState: false,
  onSearchValidate: () => ({}),
  initialContrats: undefined,
  isContratsAlreadySet: false,
  organizationSetted: false,
  forceReset: false,
  forceUnfold: false,
  isCollapsedSearch: false,
  onHandlerCollapsedSearch: undefined,
  onContratsSetted: undefined,
  selectedContrats: undefined,
  displaySelected: true,
  disabledSearch: false,
  expandedMode: false,
  isBandeau: false,
}

export default SmartSelectContract
